<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Jobs/Pools') }}</h4>
        </div>
        <div class="btn-row">
          <div
            class="btn-group">
            <button
              type="button"
              class="btn"
              :class="entity === 'jobs' ? 'btn-secondary' : 'btn-light'"
              @click="entity = 'jobs'">{{ $t('Jobs') }}</button>
            <button
              type="button"
              class="btn"
              :class="entity === 'talent_pools' ? 'btn-secondary' : 'btn-light'"
              @click="entity = 'talent_pools'">{{ $t('Talent Pools') }}</button>
          </div>

          <div>
            <select
              class="form-control"
              v-model="scope">
              <option
                value="all">
                {{ $t('All') }}
              </option>
              <option
                value="mine">
                {{ $t('Mine') }}
              </option>
            </select>
          </div>

          <button 
            v-if="permissions.includes('manage_jobs') && entity === 'jobs'"
            type="button" 
            class="btn btn-primary" 
            @click="showCreateModal({ is_talent_pool: false })">
            + {{ $t('New job') }}
            </button>

          <button
            v-if="permissions.includes('manage_jobs') && entity === 'talent_pools'"
            type="button" 
            class="btn btn-primary" 
            @click="showCreateModal({ is_talent_pool: true })">
            + {{ $t('New talent pool') }}
            </button>
        </div>
      </div>

    </div>

    <div class="vflex-row-1">
      
      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">
        
        <Paginaty
          :total="paginate.total"
          :pages="paginate.pages"
          :page="paginate.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <JobListDefault
              v-if="entity === 'jobs'"
              :jobs="jobs"
              :sort="sort"
              @setSort="setSort" />
            <JobListPool
              v-else
              :jobs="jobs"
              :sort="sort"
              @setSort="setSort" />
          </template>

          <template
            slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>

      <job-form
        v-if="modal_select"
        :initJob="modal_select" 
        @hideModal="hideModal()" 
        @deleted="loadData(); hideModal()" 
        @saved="redirectToJob">
        </job-form>

    </div>

  </div>

</template>

<script>
import JobForm from '@/components/JobForm/JobForm'
import Filterfy from '@/components/Filterfy/Filterfy'
import PointStatus from '@/components/Parts/PointStatus'
import Deadline from '@/components/Parts/Deadline'
import ThSort from '@/components/Parts/ThSort'
import RelatedUser from '@/components/Parts/RelatedUser'
import Paginaty from '@/components/Paginaty/Paginaty'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import JobListDefault from './JobListDefault'
import JobListPool from './JobListPool'

export default {
  name: 'JobList',
  components: {
    JobForm,
    Filterfy,
    Deadline,
    ThSort,
    PointStatus,
    RelatedUser,
    Paginaty,
    JobListDefault,
    JobListPool
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      filtersMap: [
        {
          'type': 'keyword',
          'label': this.$t('Title'),
          'target': 'title'
        },
        {
          'type': 'keyword',
          'label': this.$t('Hiring manager'),
          'target': 'hiring_manager_name'
        },
        {
          'type': 'list',
          'label': 'Status',
          'target': 'status',
          'resource': 'job_status'
        },
        {
          'type': 'list',
          'label': this.$t('Companies'),
          'target': 'company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Departaments'),
          'target': 'departament_id',
          'resource': 'departaments'
        },
        {
          'type': 'list',
          'label': 'Tags',
          'target': 'tags',
          'resource': 'job-tags'
        },
        {
          'type': 'list',
          'label': this.$t('Owner'),
          'target': 'owner_user_id',
          'resource': 'users'
        }
      ]
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    jobs () {
      return this.$store.getters.getJobs
    },
    paginate () {
      return this.$store.getters.getJobsPaginate
    },
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-created_at'
    },
    entity: {
      set (value) {
        this.$changeUrlParam({ entity: value })
        this.loadData()
      },
      get () {
        const entityType = this.$route.query.entity
        if (entityType === 'talent_pools') {
          return entityType
        }
        return 'jobs'
      }
    },
    scope: {
      set (value) {
        this.$changeUrlParam({ scope: value })
        this.loadData()
      },
      get () {
        const scope = this.$route.query.scope
        if (scope === 'mine') {
          return scope
        }
        return 'all'
      }
    },
    globalFilters () {
      const filters = {
        is_talent_pool: this.entity === 'talent_pools'
      }

      if (this.scope === 'mine') {
        filters.team = this.$store.getters.getMe._id
      }

      return filters
    }
  },
  metaInfo () {
    return {
      title: this.$t('Jobs/Pools')
    }
  },
  created () {
    const filters = {}
    if (!this.filters.status) {
      filters.status = ['open']
    }
    if (!this.filters.entity) {
      filters.entity = 'jobs'
    }
    if (!this.filters.scope) {
      filters.scope = 'all'
    }
    if (Object.keys(filters).length > 0) {
      this.$changeUrlParam(filters)
    }
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        ...this.globalFilters,
        page: this.$route.query.page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectJobs', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.setPage(1)
        this.loading = this.creating = false
      })
    },
    /*
    modal
    */
    showCreateModal (params) {
      this.modal_select = params
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    /*
    redirectToJob
    */
    redirectToJob (job) {
      this.$router.push({path: '/job/' + job._id})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/JobList/JobList.vue